import { useQuery } from "@tanstack/react-query";
import { listUsers, getSystemStats } from "../../api/admin.api";
import { UserTable } from "./UserTable";
import { DefaultQuotaEditor } from "./DefaultQuotaEditor";
import { Spinner } from "../ui/Spinner";
import { formatBytes } from "../../utils/formatBytes";

export default function AdminDashboard() {
  const usersQuery = useQuery({
    queryKey: ["admin", "users"],
    queryFn: listUsers,
  });

  const statsQuery = useQuery({
    queryKey: ["admin", "stats"],
    queryFn: getSystemStats,
  });

  const stats = statsQuery.data;

  return (
    <div className="space-y-4 p-4 md:space-y-6 md:p-6">
      <h1 className="text-xl font-bold text-white md:text-2xl">Admin Control Center</h1>

      {/* Stats */}
      {stats && (
        <div className="grid grid-cols-2 gap-4 md:grid-cols-3">
          <div className="rounded-xl border border-gray-700 bg-gray-900 p-4">
            <p className="text-xs text-gray-500 uppercase tracking-wide">Approved Users</p>
            <p className="mt-1 text-3xl font-bold text-white">{stats.approvedUsers}</p>
          </div>
          <div className="rounded-xl border border-gray-700 bg-gray-900 p-4">
            <p className="text-xs text-gray-500 uppercase tracking-wide">Total Used</p>
            <p className="mt-1 text-2xl font-bold text-brand-400">
              {formatBytes(stats.totalUsedBytes)}
            </p>
          </div>
          <div className="rounded-xl border border-gray-700 bg-gray-900 p-4">
            <p className="text-xs text-gray-500 uppercase tracking-wide">Total Quota</p>
            <p className="mt-1 text-2xl font-bold text-white">
              {formatBytes(stats.totalQuotaBytes)}
            </p>
          </div>
        </div>
      )}

      {/* System Settings */}
      <div className="rounded-xl border border-gray-700 bg-gray-900">
        <div className="border-b border-gray-700 px-6 py-4">
          <h2 className="text-lg font-semibold text-white">System Settings</h2>
        </div>
        <div className="px-6 py-4">
          <DefaultQuotaEditor />
        </div>
      </div>

      {/* User table */}
      <div className="rounded-xl border border-gray-700 bg-gray-900">
        <div className="border-b border-gray-700 px-6 py-4">
          <h2 className="text-lg font-semibold text-white">Users</h2>
        </div>
        {usersQuery.isLoading ? (
          <div className="flex items-center justify-center p-8">
            <Spinner />
          </div>
        ) : (
          <UserTable
            users={usersQuery.data ?? []}
            onRefresh={() => usersQuery.refetch()}
          />
        )}
      </div>
    </div>
  );
}
